// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ============================== */
/* treballs.css                   */
/* Classes específiques de Tasques, Agrupacions i Organització */
/* ============================== */

/* --- Capçalera info treball --- */
.treballs-header-info {
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
  margin-bottom: 10px;
  font-size: 14px;
}

.treballs-header-info .info-inline {
  margin-right: 18px;
}

/* --- Barra de filtres --- */
.treballs-filtres {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  align-items: center;
  margin-bottom: 10px;
  padding: 8px;
  background: #f4f4f9;
  border: 1px solid #e0e0e0;
  border-radius: 6px;
}

.treballs-filtres label {
  display: flex;
  align-items: center;
  gap: 4px;
  font-size: 13px;
  font-weight: bold;
  white-space: nowrap;
}

.treballs-filtres select,
.treballs-filtres input[type="text"] {
  padding: 4px 6px;
  font-size: 13px;
  border: 1px solid #ccc;
  border-radius: 4px;
  min-width: 100px;
}

/* --- Selector de vista --- */
.treballs-vista-selector {
  display: flex;
  gap: 4px;
  margin-bottom: 8px;
}

.treballs-vista-selector button {
  padding: 5px 14px;
  font-size: 13px;
  font-weight: bold;
  border: 1px solid #ccc;
  border-radius: 4px 4px 0 0;
  background: #f1f1f1;
  cursor: pointer;
  transition: background-color 0.2s;
}

.treballs-vista-selector button:hover {
  background: #e0e0e0;
}

.treballs-vista-selector button.active {
  background: #fff;
  border-bottom: 2px solid #fff;
  color: #0078d7;
}

/* --- Dates previstes vs reals --- */
.treballs-date-prevista {
  font-style: italic;
  color: #999;
}

/* --- Fletxa expandir/plegar --- */
.treballs-expand-arrow {
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
  display: inline-block;
  width: 18px;
  text-align: center;
  font-size: 12px;
  color: #aaa;
}

.treballs-expand-arrow.has-children {
  color: #d9534f;
}

.treballs-expand-arrow:hover {
  color: #0078d7;
}

/* --- Tab subtasca (vermell) --- */
.Dashboard-tab.tab-subtasca {
  color: #d9534f;
  border-color: #d9534f;
}

.Dashboard-tab.tab-subtasca.active {
  background: #d9534f;
  color: #fff;
  border-color: #d9534f;
}

/* --- Indentació jeràrquica --- */
.treballs-level-0 { padding-left: 4px; }
.treballs-level-1 { padding-left: 24px; }
.treballs-level-2 { padding-left: 44px; }
.treballs-level-3 { padding-left: 64px; }

/* ============================== */
/* Agrupacions: layout 2 columnes */
/* ============================== */
.treballs-agrup-layout {
  display: flex;
  gap: 12px;
  height: 100%;
  min-height: 300px;
}

.treballs-agrup-panel-left {
  width: 260px;
  min-width: 200px;
  border-right: 1px solid #ddd;
  padding-right: 10px;
  display: flex;
  flex-direction: column;
}

.treballs-agrup-panel-left .agrup-list {
  flex: 1 1;
  overflow-y: auto;
}

.treballs-agrup-panel-left .agrup-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 6px 8px;
  margin-bottom: 4px;
  border: 1px solid #e0e0e0;
  border-radius: 4px;
  cursor: pointer;
  font-size: 13px;
  transition: background 0.15s;
}

.treballs-agrup-panel-left .agrup-item:hover {
  background: #f0f0f0;
}

.treballs-agrup-panel-left .agrup-item.selected {
  background: #cce5ff;
  border-color: #007bff;
  font-weight: bold;
}

.treballs-agrup-panel-left .agrup-actions {
  display: flex;
  gap: 4px;
  padding: 6px 0;
  border-bottom: 1px solid #ddd;
  margin-bottom: 6px;
}

.treballs-agrup-panel-center {
  flex: 1 1;
  overflow: auto;
}

/* ============================== */
/* Organització: layout 2 panells */
/* ============================== */
.treballs-org-layout {
  display: flex;
  gap: 12px;
  height: 100%;
  min-height: 300px;
}

.treballs-org-panel-left {
  flex: 1 1;
  border-right: 1px solid #ddd;
  padding-right: 10px;
  display: flex;
  flex-direction: column;
  overflow: auto;
}

.treballs-org-panel-right {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  overflow: auto;
}

.treballs-org-panel-right .org-rel-header {
  display: flex;
  gap: 8px;
  align-items: center;
  margin-bottom: 8px;
  flex-wrap: wrap;
}

/* ============================== */
/* Resum: KPIs                    */
/* ============================== */
.treballs-resum-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(180px, 1fr));
  gap: 12px;
  margin-bottom: 16px;
}

.treballs-resum-kpi {
  background: #fff;
  border: 1px solid #ddd;
  border-radius: 8px;
  padding: 14px;
  text-align: center;
  box-shadow: 0 1px 3px rgba(0,0,0,0.06);
}

.treballs-resum-kpi .kpi-value {
  font-size: 28px;
  font-weight: bold;
  color: #0078d7;
  margin-bottom: 4px;
}

.treballs-resum-kpi .kpi-label {
  font-size: 13px;
  color: #666;
}

.treballs-resum-kpi.kpi-warning .kpi-value {
  color: #d9534f;
}

.treballs-resum-kpi.kpi-success .kpi-value {
  color: #28a745;
}

/* ============================== */
/* Multi-select (mode Agrupar)    */
/* ============================== */
.treballs-multiselect-row {
  display: flex;
  align-items: center;
  gap: 6px;
}

.treballs-multiselect-row input[type="checkbox"] {
  width: 16px;
  height: 16px;
  cursor: pointer;
}

/* --- Badge de mode --- */
.treballs-mode-badge {
  display: inline-block;
  padding: 3px 10px;
  font-size: 12px;
  font-weight: bold;
  border-radius: 12px;
  margin-left: 8px;
}

.treballs-mode-badge.mode-normal {
  background: #e8f4ff;
  color: #0078d7;
}

.treballs-mode-badge.mode-agrupar {
  background: #fff3cd;
  color: #856404;
}

/* --- Formulari agrupació inline --- */
.treballs-agrup-form {
  padding: 10px;
  background: #f9f9f9;
  border: 1px solid #ddd;
  border-radius: 6px;
  margin-bottom: 8px;
}

.treballs-agrup-form label {
  display: flex;
  flex-direction: column;
  font-size: 13px;
  font-weight: bold;
  margin-bottom: 6px;
}

.treballs-agrup-form input,
.treballs-agrup-form textarea,
.treballs-agrup-form select {
  padding: 4px 6px;
  font-size: 13px;
  border: 1px solid #ccc;
  border-radius: 4px;
  margin-top: 2px;
}

/* --- Motiu en organització --- */
.treballs-org-motiu-input {
  width: 100%;
  padding: 4px 6px;
  font-size: 13px;
  border: 1px solid #ccc;
  border-radius: 4px;
  margin-top: 4px;
}

/* --- Taula tasques dins d'agrupacions/organització --- */
.treballs-tasca-mini-row {
  padding: 5px 8px;
  border-bottom: 1px solid #eee;
  cursor: pointer;
  font-size: 13px;
  transition: background 0.15s;
}

.treballs-tasca-mini-row:hover {
  background: #f0f0f0;
}

.treballs-tasca-mini-row.selected {
  background: #cce5ff;
  font-weight: bold;
}

/* --- Barres d'execució Resum --- */
.treballs-resum-execucio {
  margin-top: 16px;
  padding: 12px;
  background: #fafafa;
  border: 1px solid #e0e0e0;
  border-radius: 6px;
}

.treballs-resum-execucio h4 {
  margin: 0 0 12px 0;
  font-size: 15px;
}

.treballs-resum-barra {
  margin-bottom: 14px;
}

.treballs-resum-barra .barra-label {
  display: flex;
  justify-content: space-between;
  font-size: 13px;
  margin-bottom: 4px;
}

.treballs-resum-barra .barra-track {
  height: 18px;
  background: #e9ecef;
  border-radius: 9px;
  overflow: hidden;
}

.treballs-resum-barra .barra-fill {
  height: 100%;
  background: linear-gradient(90deg, #28a745, #5cb85c);
  border-radius: 9px;
  transition: width 0.5s ease;
  min-width: 0;
}

.treballs-resum-barra .barra-valors {
  display: flex;
  justify-content: space-between;
  font-size: 11px;
  color: #888;
  margin-top: 2px;
}

/* Responsive */
@media (max-width: 768px) {
  .treballs-agrup-layout,
  .treballs-org-layout {
    flex-direction: column;
  }

  .treballs-agrup-panel-left,
  .treballs-org-panel-left {
    width: 100%;
    border-right: none;
    border-bottom: 1px solid #ddd;
    padding-right: 0;
    padding-bottom: 10px;
    margin-bottom: 10px;
  }

  .treballs-resum-grid {
    grid-template-columns: repeat(auto-fill, minmax(140px, 1fr));
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/dashboard/treballs.css"],"names":[],"mappings":"AAAA,mCAAmC;AACnC,mCAAmC;AACnC,gEAAgE;AAChE,mCAAmC;;AAEnC,mCAAmC;AACnC;EACE,aAAa;EACb,eAAe;EACf,SAAS;EACT,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,kBAAkB;AACpB;;AAEA,6BAA6B;AAC7B;EACE,aAAa;EACb,eAAe;EACf,SAAS;EACT,mBAAmB;EACnB,mBAAmB;EACnB,YAAY;EACZ,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;;EAEE,gBAAgB;EAChB,eAAe;EACf,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA,8BAA8B;AAC9B;EACE,aAAa;EACb,QAAQ;EACR,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,iBAAiB;EACjB,sBAAsB;EACtB,0BAA0B;EAC1B,mBAAmB;EACnB,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,6BAA6B;EAC7B,cAAc;AAChB;;AAEA,qCAAqC;AACrC;EACE,kBAAkB;EAClB,WAAW;AACb;;AAEA,mCAAmC;AACnC;EACE,eAAe;EACf,yBAAiB;UAAjB,iBAAiB;EACjB,qBAAqB;EACrB,WAAW;EACX,kBAAkB;EAClB,eAAe;EACf,WAAW;AACb;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA,mCAAmC;AACnC;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,qBAAqB;AACvB;;AAEA,kCAAkC;AAClC,oBAAoB,iBAAiB,EAAE;AACvC,oBAAoB,kBAAkB,EAAE;AACxC,oBAAoB,kBAAkB,EAAE;AACxC,oBAAoB,kBAAkB,EAAE;;AAExC,mCAAmC;AACnC,mCAAmC;AACnC,mCAAmC;AACnC;EACE,aAAa;EACb,SAAS;EACT,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,4BAA4B;EAC5B,mBAAmB;EACnB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,SAAO;EACP,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,4BAA4B;AAC9B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,cAAc;EACd,6BAA6B;EAC7B,kBAAkB;AACpB;;AAEA;EACE,SAAO;EACP,cAAc;AAChB;;AAEA,mCAAmC;AACnC,mCAAmC;AACnC,mCAAmC;AACnC;EACE,aAAa;EACb,SAAS;EACT,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,SAAO;EACP,4BAA4B;EAC5B,mBAAmB;EACnB,aAAa;EACb,sBAAsB;EACtB,cAAc;AAChB;;AAEA;EACE,SAAO;EACP,aAAa;EACb,sBAAsB;EACtB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;AACjB;;AAEA,mCAAmC;AACnC,mCAAmC;AACnC,mCAAmC;AACnC;EACE,aAAa;EACb,4DAA4D;EAC5D,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,sBAAsB;EACtB,kBAAkB;EAClB,aAAa;EACb,kBAAkB;EAClB,sCAAsC;AACxC;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,WAAW;AACb;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA,mCAAmC;AACnC,mCAAmC;AACnC,mCAAmC;AACnC;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;AACjB;;AAEA,0BAA0B;AAC1B;EACE,qBAAqB;EACrB,iBAAiB;EACjB,eAAe;EACf,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA,uCAAuC;AACvC;EACE,aAAa;EACb,mBAAmB;EACnB,sBAAsB;EACtB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;;;EAGE,gBAAgB;EAChB,eAAe;EACf,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;AACjB;;AAEA,kCAAkC;AAClC;EACE,WAAW;EACX,gBAAgB;EAChB,eAAe;EACf,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;AACjB;;AAEA,0DAA0D;AAC1D;EACE,gBAAgB;EAChB,6BAA6B;EAC7B,eAAe;EACf,eAAe;EACf,4BAA4B;AAC9B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA,oCAAoC;AACpC;EACE,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,oDAAoD;EACpD,kBAAkB;EAClB,2BAA2B;EAC3B,YAAY;AACd;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,eAAe;EACf,WAAW;EACX,eAAe;AACjB;;AAEA,eAAe;AACf;EACE;;IAEE,sBAAsB;EACxB;;EAEA;;IAEE,WAAW;IACX,kBAAkB;IAClB,6BAA6B;IAC7B,gBAAgB;IAChB,oBAAoB;IACpB,mBAAmB;EACrB;;EAEA;IACE,4DAA4D;EAC9D;AACF","sourcesContent":["/* ============================== */\n/* treballs.css                   */\n/* Classes específiques de Tasques, Agrupacions i Organització */\n/* ============================== */\n\n/* --- Capçalera info treball --- */\n.treballs-header-info {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 16px;\n  margin-bottom: 10px;\n  font-size: 14px;\n}\n\n.treballs-header-info .info-inline {\n  margin-right: 18px;\n}\n\n/* --- Barra de filtres --- */\n.treballs-filtres {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 10px;\n  align-items: center;\n  margin-bottom: 10px;\n  padding: 8px;\n  background: #f4f4f9;\n  border: 1px solid #e0e0e0;\n  border-radius: 6px;\n}\n\n.treballs-filtres label {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  font-size: 13px;\n  font-weight: bold;\n  white-space: nowrap;\n}\n\n.treballs-filtres select,\n.treballs-filtres input[type=\"text\"] {\n  padding: 4px 6px;\n  font-size: 13px;\n  border: 1px solid #ccc;\n  border-radius: 4px;\n  min-width: 100px;\n}\n\n/* --- Selector de vista --- */\n.treballs-vista-selector {\n  display: flex;\n  gap: 4px;\n  margin-bottom: 8px;\n}\n\n.treballs-vista-selector button {\n  padding: 5px 14px;\n  font-size: 13px;\n  font-weight: bold;\n  border: 1px solid #ccc;\n  border-radius: 4px 4px 0 0;\n  background: #f1f1f1;\n  cursor: pointer;\n  transition: background-color 0.2s;\n}\n\n.treballs-vista-selector button:hover {\n  background: #e0e0e0;\n}\n\n.treballs-vista-selector button.active {\n  background: #fff;\n  border-bottom: 2px solid #fff;\n  color: #0078d7;\n}\n\n/* --- Dates previstes vs reals --- */\n.treballs-date-prevista {\n  font-style: italic;\n  color: #999;\n}\n\n/* --- Fletxa expandir/plegar --- */\n.treballs-expand-arrow {\n  cursor: pointer;\n  user-select: none;\n  display: inline-block;\n  width: 18px;\n  text-align: center;\n  font-size: 12px;\n  color: #aaa;\n}\n\n.treballs-expand-arrow.has-children {\n  color: #d9534f;\n}\n\n.treballs-expand-arrow:hover {\n  color: #0078d7;\n}\n\n/* --- Tab subtasca (vermell) --- */\n.Dashboard-tab.tab-subtasca {\n  color: #d9534f;\n  border-color: #d9534f;\n}\n\n.Dashboard-tab.tab-subtasca.active {\n  background: #d9534f;\n  color: #fff;\n  border-color: #d9534f;\n}\n\n/* --- Indentació jeràrquica --- */\n.treballs-level-0 { padding-left: 4px; }\n.treballs-level-1 { padding-left: 24px; }\n.treballs-level-2 { padding-left: 44px; }\n.treballs-level-3 { padding-left: 64px; }\n\n/* ============================== */\n/* Agrupacions: layout 2 columnes */\n/* ============================== */\n.treballs-agrup-layout {\n  display: flex;\n  gap: 12px;\n  height: 100%;\n  min-height: 300px;\n}\n\n.treballs-agrup-panel-left {\n  width: 260px;\n  min-width: 200px;\n  border-right: 1px solid #ddd;\n  padding-right: 10px;\n  display: flex;\n  flex-direction: column;\n}\n\n.treballs-agrup-panel-left .agrup-list {\n  flex: 1;\n  overflow-y: auto;\n}\n\n.treballs-agrup-panel-left .agrup-item {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 6px 8px;\n  margin-bottom: 4px;\n  border: 1px solid #e0e0e0;\n  border-radius: 4px;\n  cursor: pointer;\n  font-size: 13px;\n  transition: background 0.15s;\n}\n\n.treballs-agrup-panel-left .agrup-item:hover {\n  background: #f0f0f0;\n}\n\n.treballs-agrup-panel-left .agrup-item.selected {\n  background: #cce5ff;\n  border-color: #007bff;\n  font-weight: bold;\n}\n\n.treballs-agrup-panel-left .agrup-actions {\n  display: flex;\n  gap: 4px;\n  padding: 6px 0;\n  border-bottom: 1px solid #ddd;\n  margin-bottom: 6px;\n}\n\n.treballs-agrup-panel-center {\n  flex: 1;\n  overflow: auto;\n}\n\n/* ============================== */\n/* Organització: layout 2 panells */\n/* ============================== */\n.treballs-org-layout {\n  display: flex;\n  gap: 12px;\n  height: 100%;\n  min-height: 300px;\n}\n\n.treballs-org-panel-left {\n  flex: 1;\n  border-right: 1px solid #ddd;\n  padding-right: 10px;\n  display: flex;\n  flex-direction: column;\n  overflow: auto;\n}\n\n.treballs-org-panel-right {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  overflow: auto;\n}\n\n.treballs-org-panel-right .org-rel-header {\n  display: flex;\n  gap: 8px;\n  align-items: center;\n  margin-bottom: 8px;\n  flex-wrap: wrap;\n}\n\n/* ============================== */\n/* Resum: KPIs                    */\n/* ============================== */\n.treballs-resum-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(180px, 1fr));\n  gap: 12px;\n  margin-bottom: 16px;\n}\n\n.treballs-resum-kpi {\n  background: #fff;\n  border: 1px solid #ddd;\n  border-radius: 8px;\n  padding: 14px;\n  text-align: center;\n  box-shadow: 0 1px 3px rgba(0,0,0,0.06);\n}\n\n.treballs-resum-kpi .kpi-value {\n  font-size: 28px;\n  font-weight: bold;\n  color: #0078d7;\n  margin-bottom: 4px;\n}\n\n.treballs-resum-kpi .kpi-label {\n  font-size: 13px;\n  color: #666;\n}\n\n.treballs-resum-kpi.kpi-warning .kpi-value {\n  color: #d9534f;\n}\n\n.treballs-resum-kpi.kpi-success .kpi-value {\n  color: #28a745;\n}\n\n/* ============================== */\n/* Multi-select (mode Agrupar)    */\n/* ============================== */\n.treballs-multiselect-row {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n}\n\n.treballs-multiselect-row input[type=\"checkbox\"] {\n  width: 16px;\n  height: 16px;\n  cursor: pointer;\n}\n\n/* --- Badge de mode --- */\n.treballs-mode-badge {\n  display: inline-block;\n  padding: 3px 10px;\n  font-size: 12px;\n  font-weight: bold;\n  border-radius: 12px;\n  margin-left: 8px;\n}\n\n.treballs-mode-badge.mode-normal {\n  background: #e8f4ff;\n  color: #0078d7;\n}\n\n.treballs-mode-badge.mode-agrupar {\n  background: #fff3cd;\n  color: #856404;\n}\n\n/* --- Formulari agrupació inline --- */\n.treballs-agrup-form {\n  padding: 10px;\n  background: #f9f9f9;\n  border: 1px solid #ddd;\n  border-radius: 6px;\n  margin-bottom: 8px;\n}\n\n.treballs-agrup-form label {\n  display: flex;\n  flex-direction: column;\n  font-size: 13px;\n  font-weight: bold;\n  margin-bottom: 6px;\n}\n\n.treballs-agrup-form input,\n.treballs-agrup-form textarea,\n.treballs-agrup-form select {\n  padding: 4px 6px;\n  font-size: 13px;\n  border: 1px solid #ccc;\n  border-radius: 4px;\n  margin-top: 2px;\n}\n\n/* --- Motiu en organització --- */\n.treballs-org-motiu-input {\n  width: 100%;\n  padding: 4px 6px;\n  font-size: 13px;\n  border: 1px solid #ccc;\n  border-radius: 4px;\n  margin-top: 4px;\n}\n\n/* --- Taula tasques dins d'agrupacions/organització --- */\n.treballs-tasca-mini-row {\n  padding: 5px 8px;\n  border-bottom: 1px solid #eee;\n  cursor: pointer;\n  font-size: 13px;\n  transition: background 0.15s;\n}\n\n.treballs-tasca-mini-row:hover {\n  background: #f0f0f0;\n}\n\n.treballs-tasca-mini-row.selected {\n  background: #cce5ff;\n  font-weight: bold;\n}\n\n/* --- Barres d'execució Resum --- */\n.treballs-resum-execucio {\n  margin-top: 16px;\n  padding: 12px;\n  background: #fafafa;\n  border: 1px solid #e0e0e0;\n  border-radius: 6px;\n}\n\n.treballs-resum-execucio h4 {\n  margin: 0 0 12px 0;\n  font-size: 15px;\n}\n\n.treballs-resum-barra {\n  margin-bottom: 14px;\n}\n\n.treballs-resum-barra .barra-label {\n  display: flex;\n  justify-content: space-between;\n  font-size: 13px;\n  margin-bottom: 4px;\n}\n\n.treballs-resum-barra .barra-track {\n  height: 18px;\n  background: #e9ecef;\n  border-radius: 9px;\n  overflow: hidden;\n}\n\n.treballs-resum-barra .barra-fill {\n  height: 100%;\n  background: linear-gradient(90deg, #28a745, #5cb85c);\n  border-radius: 9px;\n  transition: width 0.5s ease;\n  min-width: 0;\n}\n\n.treballs-resum-barra .barra-valors {\n  display: flex;\n  justify-content: space-between;\n  font-size: 11px;\n  color: #888;\n  margin-top: 2px;\n}\n\n/* Responsive */\n@media (max-width: 768px) {\n  .treballs-agrup-layout,\n  .treballs-org-layout {\n    flex-direction: column;\n  }\n\n  .treballs-agrup-panel-left,\n  .treballs-org-panel-left {\n    width: 100%;\n    border-right: none;\n    border-bottom: 1px solid #ddd;\n    padding-right: 0;\n    padding-bottom: 10px;\n    margin-bottom: 10px;\n  }\n\n  .treballs-resum-grid {\n    grid-template-columns: repeat(auto-fill, minmax(140px, 1fr));\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
